export const genderOptions = [
    {
        value: 'MALE',
        label: 'He/Him'
    },
    {
        value: 'FEMALE',
        label: 'She/Her'
    },
    {
        value: 'THEY',
        label: 'They/Them'
    },
    {
        value: 'OTHER',
        label: 'Other'
    },
        {
        value: 'DECLINE',
        label: 'Decline To Answer'
    }
];